import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { PrimaryActionButton, Box } from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import TitleSection from 'Views/Page/Content/Modal/Components/TitleSection';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import ActionsRow from 'Components/ComponentLibrary/Atoms/Layout/ActionsRow';
import { useSnackbarContext } from 'Context/SnackbarContext';

const styles = (theme) => ({
  root: {},
  formContainer: {
    padding: theme.spacing(2),
  },
});

const Layout = ({
  classes,
}) => {
  const { resource } = useMetaLayoutContext();
  const { displayErrorMessage, displaySuccess } = useSnackbarContext();
  const [loading, setLoading] = useState(false);
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await resource.submit();
      await refreshPageContentCollection();
      displaySuccess('Nickname saved');
      clearModalCollection();
    } catch (e) {
      displayErrorMessage(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <TitleSection />
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      <ActionsRow>
        <PrimaryActionButton
          onClick={handleSubmit}
          loading={loading}
          disabled={loading}
          label={loading ? 'Saving Nickname' : 'Save Nickname'}
          isFullWidth
          size="lg"
        />
      </ActionsRow>
    </Box>
  );
};

Layout.defaultProps = {
};

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
